import Vue from 'vue'
/**
 * @author  José Luis Ruiz
 * Authorize quantification
 * @param id Quantification's id
 * @return promise
 */
const affectedVisibleRepports = ({ id }) =>
  Vue.$http.post(`purchase/authorize_quantification/${id}/`)
    .catch(err => { throw err })

export default affectedVisibleRepports



// WEBPACK FOOTER //
// ./src/services/sinister/authorizeQuantification.js